/* eslint-disable import/no-unresolved */
import axios from "axios";
import API_URLS from "src/config/API_URLS";
import axiosInstance from "src/utils/Axios/axiosInstance";
import StorageService from "src/utils/Storage/storageService";

const loginCall = async (credentials: Record<string, any>) => {
  try {
    const response = await axiosInstance.post(API_URLS.login, credentials);
    return response;
  } catch (response: any) {
    if (response?.data?.userId) {
      throw response;
    } else {
      throw new Error(response?.data?.error?.message);
    }
  }
};

export const sendLoginOtpCall = async (payload: Record<string, any>) => {
  try {
    const response = await axiosInstance.post(API_URLS.sendLoginOtp, payload);
    return response;
  } catch (error: any) {
    if (error?.data?.userId) {
      throw error;
    } else {
      throw new Error(error?.data?.error?.message || "Failed to send OTP");
    }
  }
};

export const resentLoginOtp = async (payload: Record<string, any>) => {
  try {
    const response = await axiosInstance.post(API_URLS.resendLoginOtp, payload);
    return response;
  } catch (error: any) {
    if (error?.data?.userId) {
      throw error;
    } else {
      throw new Error(error?.data?.error?.message || "Failed to resend OTP");
    }
  }
};

export const verifyLoginOtp = async (payload: Record<string, any>) => {
  try {
    const response = await axiosInstance.post(API_URLS.validateLoginOtp, payload);
    return response;
  } catch (error: any) {
    if (error?.data?.userId) {
      throw error;
    } else {
      throw new Error(error?.data?.error?.message || "OTP Verification Failed");
    }
  }
};

export const constructSAMLUri = (partnerCode: string) =>
  `${API_URLS.baseURL}${API_URLS.samlLogin}?partnerCode=${partnerCode}`;

export const samlLoginGetUser = async () => {
  try {
    const samlToken = StorageService.getFromLocalStorage("samlToken");
    const response = await axios.get(`${API_URLS.baseURL}${API_URLS.samlGetUser}`, {
      headers: {
        Authorization: `Bearer ${samlToken}`
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export default loginCall;
